import { render, staticRenderFns } from "./ClinicIntro.vue?vue&type=template&id=1327e1a4&scoped=true"
import script from "./ClinicIntro.vue?vue&type=script&lang=js"
export * from "./ClinicIntro.vue?vue&type=script&lang=js"
import style0 from "./ClinicIntro.vue?vue&type=style&index=0&id=1327e1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1327e1a4",
  null
  
)

export default component.exports